<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Create Program</h3>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            Program
          </template>
          <first-step ref="step1" @on-validated="firstStep"></first-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./ProgramCreateSteps/FirstStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    getExtrasField: function() {
      let extras = {}
      let extra_fields = this.$refs["step1"].extra_fields
      for (const field in extra_fields) {
        if (this.$refs["step1"][extra_fields[field]]) {
          extras[extra_fields[field]] = this.$refs["step1"][extra_fields[field]]
        }
      }
      return extras
    },
    getfirstStepData() {
      var data = {
        name: this.$refs["step1"].name,
        university: this.$refs["step1"].university,
        application_autumn_start_date: this.$refs["step1"]
          .application_autumn_start_date,
        application_autumn_end_date: this.$refs["step1"]
          .application_autumn_end_date,
        application_spring_start_date: this.$refs["step1"]
          .application_spring_start_date,
        application_spring_end_date: this.$refs["step1"]
          .application_spring_end_date,
        lesson_start_date: this.$refs["step1"].lesson_start_date,
        type: this.$refs["step1"].type,
        price: this.$refs["step1"].price,
        discounted_price: this.$refs["step1"].discounted_price,
        commission: this.$refs["step1"].commission,
        currency: this.$refs["step1"].currency,
        prep_price: this.$refs["step1"].prep_price,
        prep_price_2: this.$refs["step1"].prep_price_2,
        scope: this.$refs["step1"].scope,
        education_duration: this.$refs["step1"].education_duration,
        quota: this.$refs["step1"].quota,
        education_type: this.$refs["step1"].education_type,
        campus_type: this.$refs["step1"].campus_type,
        education_language: this.$store.languages[
          this.$refs["step1"].education_language
        ],
        city: this.$refs["step1"].city,
        address: this.$refs["step1"].address,
        website: this.$refs["step1"].website,
        detail: this.$refs["step1"].detail,
        modules: this.$refs["step1"].modules,
        admission_and_fees: this.$refs["step1"].admission_and_fees,
        installments: this.$refs["step1"].installments,
        deposit: this.$refs["step1"].deposit,
        refund_policy: this.$refs["step1"].refund_policy,
        is_quota_full: this.$refs["step1"].is_quota_full,
        requirements: this.$refs["step1"].requirements,
        notes: this.$refs["step1"].notes,
        extras: this.getExtrasField()
      };
      var post_data = {};
      for (const field in data) {
        if (data[field]) {
          if (data[field] instanceof Date) {
            post_data[field] = data[field]
              .toLocaleDateString("ko-KR")
              .replaceAll(". ", "-")
              .replaceAll(".", "");
          } else {
            post_data[field] = data[field];
          }
        }
      }
      return post_data;
    },
    firstStep(validated, model) {
      if (validated) {
        let data = this.getfirstStepData();
        this.$store
          .createProgram(data)
          .then(response => {
            this.wizardComplete();
          })
          .catch(error => {
            var message = error.response.data;
            this.$notify({
              message: JSON.stringify(message),
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top",
              timeout: 5000
            });
          });
      }
      this.wizardModel = { ...this.wizardModel, ...model };
      return validated;
    },
    wizardComplete() {
      Swal.fire({
        title: "Program created.",
        text: "Finish",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      }).then(result => {
        this.$router.push({ name: "Program List" });
      });
    }
  }
};
</script>
